export const hideDealerCostProductCodes: string[] = ['CBLO', 'CBLP', 'CBFY'];
